import type lzutf8Type from "lzutf8";

let lzModule: typeof lzutf8Type | null = null;

async function getLz() {
  if (!lzModule) {
    const mod = await import("lzutf8");
    lzModule = mod.default ?? mod;
  }
  return lzModule;
}

export async function compressToBase64(data: string): Promise<string> {
  const lz = await getLz();
  return lz.encodeBase64(lz.compress(data));
}

export async function decompressFromBase64(data: string): Promise<string> {
  const lz = await getLz();
  return lz.decompress(lz.decodeBase64(data));
}
